import { IRegisteredTrackerEvent } from './registered-tracker-event.interface';

export interface ITriggerAppDto extends IRegisteredTrackerEvent {
    tripCode: string;
    checkpointIndex: number;
    stepIndex: number;
    datetime?: string;
}
